/* eslint-disable jsx-a11y/no-onchange */
/** @jsx jsx */
import { string, arrayOf } from 'prop-types'
import { jsx, Label, Text } from 'theme-ui'
import { Field } from 'formik'
import './formInputs.css'
import { Check } from '../../../icons/index'

const CheckboxGroupItem = ({ value, label, list, groupId, ...props }) => {
  return (
    <Label
      sx={{
        position: 'relative',
        pl: 30,
        cursor: 'pointer',
        userSelect: 'none',
        width: 'inherit',
      }}
      {...props}
      data-automation-id={`checkbox-group-item-${groupId}-${value}`}
    >
      <Field
        type="checkbox"
        name={groupId}
        value={value}
        sx={{
          // hide the native checkbox with opacity so click handlers still work
          position: 'absolute',
          opacity: 0,
          cursor: 'pointer',
          height: 0,
          width: 0,
        }}
      />
      <span
        sx={{
          // custom styled checkbox that replaces the hidden <input type="checkbox">
          position: 'absolute',
          top: 0,
          left: 0,
          height: 20,
          width: 20,
          bg: 'paleSilver',
          border: !list?.includes(value) ? '1px solid #979491' : undefined,
        }}
      >
        {list?.includes(value) ? <Check /> : null}
      </span>
      <Text variant="xSmallText">{label}</Text>
    </Label>
  )
}

CheckboxGroupItem.propTypes = {
  value: string,
  label: string,
  groupId: string,
  list: arrayOf(string),
}

export default CheckboxGroupItem
